import React from "react";

export const AuthContext = React.createContext ({ 
    authToken: localStorage.getItem('authToken'),
    setAuthToken: () => {}
})